const get = require('lodash/get')
const { PhoneNumberUtil } = require('google-libphonenumber')
const phoneUtil = PhoneNumberUtil.getInstance()

class SafaricomAdapter {
  constructor (logger, safaricomCredentials, isomorphicFetch) {
    this.logger = logger
    Object.assign(this, safaricomCredentials)
    this.request = isomorphicFetch
  }

  async sendSms (to, message) {
    to = Array.isArray(to) ? to : [to]

    const _to = to.map(val => `+${val}`)

    const validNumbers = _to
      .filter(number => {
        try {
          return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(number))
        } catch (error) {
          console.log(`Failed to parse phoneNumber ${number}`)
          return false
        }
      })

    if (validNumbers.length === 0) {
      throw new Error('No valid phone numbers found after validation')
    }

    const validatedNumbers = validNumbers.map(number => number.substring(1))

    const data = {
      SenderId: this.senderId,
      ApiKey: this.apiKey,
      ClientId: this.clientId,
      MessageParameters: validatedNumbers.map(val => {
        return {
          Number: val,
          Text: message
        }
      })
    }

    const response = await this.request(`${this.apiUrl}sms/SendBulkSMS`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        AccessKey: this.accessKey
      },
      body: JSON.stringify(data)
    })
    const responseData = await response.json()
    const success = responseData.ErrorCode === 0

    return {
      providerResponse: responseData,
      providerSmsId: get(responseData, 'Data[0].MessageId'),
      success,
      provider: 'SC'
    }
  }
}

module.exports = SafaricomAdapter
